import { render } from "./ListForAnnotator.vue?vue&type=template&id=e1d56dc8"
import script from "./ListForAnnotator.vue?vue&type=script&lang=js"
export * from "./ListForAnnotator.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__